import axios from "axios";
import authHeader from "./auth-header";
import ErrorService from "./error.service";
import AdminService from "./admin.service";
import UserService from "./user.service";
import ClientService from "./client.service";
import TableService from "./table.service";

import moment from "moment";
import Vue from "vue";
import $ from "jquery";

Vue.prototype.moment = moment;

const API_URL = AdminService.getBaseUrl() + "/api/v1/client";
const ADMIN_URL = AdminService.getBaseUrl() + "/api/v1/admin";

class MetricsService {
  calculateGrowth(beforeData, afterData, useValueToCalculateGrowth = false, precision = 2) {
    let growth = 0;
    let difference = afterData - beforeData;
    let isPositive = afterData > beforeData;
    if (afterData < 0 && beforeData < 0) {
      let average = (afterData + beforeData) / 2;
      growth = useValueToCalculateGrowth ? difference : (difference / Math.abs(average)) * 100;
    } else {
      growth = useValueToCalculateGrowth ? difference : (difference / beforeData) * 100;
    }
    if (!isNaN(growth) && isFinite(growth)) {
      growth = growth.toFixed(precision);
      if (isPositive && growth < 0) {
        growth = -growth;
      }
    } else {
      growth = 0;
    }
    return growth;
  }

  setMetricDropdownOptions(inputData, vm, includeAll = false) {
    vm.metric_options = [];
    $.each(inputData, function(i, item) {
      let metricOption = includeAll ? JSON.parse(JSON.stringify(item)) : {};
      metricOption.name = item.name;
      metricOption.value = String(item.metricGroupId);

      vm.metric_options.push(metricOption);

      // Create a second entry for %
      let metricOptionPercent = includeAll ? JSON.parse(JSON.stringify(item)) : {};
      metricOptionPercent.name = metricOption.name + " Growth";
      metricOptionPercent.value = String(item.metricGroupId) + "-growth";

      vm.metric_options.push(metricOptionPercent);

      if (i == 0) {
        vm.metricId = metricOption.value;
      }
    });
  }
  getPredictiveAnalyticsColumns(id,correlationType="Positive") {
    if (id == "predictive-analytics-table") {
      let returnDef = [
        TableService.getOrderSequence(),
        {
          targets: [0],
          visible: true,
          className: "predictive-text-column predictive-border-column",
          createdCell: function(td, cellData, rowData, row, col) {
            let baseClass = "predictive-text-column predictive-border-column";
            if (cellData == "Customer NPS") {
              $(td).addClass(baseClass + " customer-nps-column ");
            } else if (
              cellData == "Assurance" ||
              cellData == "Creativity" ||
              cellData == "Adaptability" ||
              cellData == "Trust" ||
              cellData == "Activity"
            ) {
              $(td).addClass(baseClass + " emotional-needs-column ");
            }
          }
        },
        {
          targets: "_all",
          width: "50px"
        }
      ];
      if (correlationType == "Negative"){
        returnDef.push(
                {
                  targets: [1, 2, 3, 4, 5, 6],
                  createdCell: function(td, cellData, rowData, row, col) {
                    if (cellData <= -0.8 && cellData >= -1.0) {
                      $(td).addClass("very-strong-correlation");
                    } else if (cellData <= -0.5 && cellData > -0.8) {
                      $(td).addClass("strong-correlation");
                    } 
                  },
                  render(v) {
                    if (v != null && !isNaN(v) && v != 0) {
                      return Number(v).toFixed(2);
                    }
                    return TableService.getEmptyCell();
                  }
                },
        );
      }
      else {
        returnDef.push(
                {
                  targets: [1, 2, 3, 4, 5, 6],
                  createdCell: function(td, cellData, rowData, row, col) {
                    if (cellData >= 0.8 && cellData <= 1.0) {
                      $(td).addClass("very-strong-correlation");
                    } else if (cellData >= 0.5 && cellData < 0.8) {
                      $(td).addClass("strong-correlation");
                    }
                  },
                  render(v) {
                    if (v != null && !isNaN(v) && v != 0) {
                      return Number(v).toFixed(2);
                    }
                    return TableService.getEmptyCell();
                  }
                },
        );
      }
      returnDef.push(TableService.getPercentTableAttribute([7], "", 50, 2));
      returnDef.push(TableService.getNumericTableAttribute([1, 2, 3, 4, 5, 6, 9], "", 50, 2));
      returnDef.push(TableService.getNumericTableAttribute([5, 6, 8, 10, 11], "predictive-border-column", 50, 2));
      return returnDef;
    } else if (id == "needs-table") {
      return [TableService.getOrderSequence(), { targets: [0], visible: false, sortable: false }, { targets: "_all", width: "50px" }];
    } else {
      return [TableService.getOrderSequence(), { targets: [0], visible: true }, { targets: "_all", width: "50px" }];
    }
  }
  getPredictiveTableAttributes(id,correlationType="Positive") {
    let buttonClass = id+"-header-container";
    return {
      id: id,
      class: "table display wrap row-border table-hover",
      columns: [],
      configuration: {
        dom: '<"w-100 ' + buttonClass + '"<"chart-header-container d-flex"><B>>frtip',
        searching: false,
        paging: false,
        select: true,
        processing: true,
        responsive: true,
        destroy: true,
        info: false,
        ordering: true,
        keys: true,
        bSort: true,
        columnDefs: this.getPredictiveAnalyticsColumns(id,correlationType),
        language: {
          decimal: ",",
          thousands: "."
        },
        buttons: []
      }
    };
  }
  async getMetricGroupByClientId(callback, chartApp) {
    if (!UserService.isLoggedIn()) {
      return;
    }
    const params = new URLSearchParams();
    params.append("userId", UserService.getUserId());
    params.append("clientCode", ClientService.getClientCode());

    await axios
      .post(API_URL + "/get-metric-groups-by-client-id", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MetricServices.getMetricGroup", error, "admin", chartApp);
      });
  }
  async getMetricGroupBySurveyCode(surveyCode, callback, chartApp) {
    if (!UserService.isLoggedIn() || surveyCode == "") {
      return;
    }
    const params = new URLSearchParams();
    params.append("userId", UserService.getUserId());
    params.append("surveyCode", surveyCode);

    await axios
      .post(API_URL + "/get-metric-groups-by-survey-code", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MetricServices.getMetricGroup", error, "admin", chartApp);
      });
  }
  async getMetricGroupBySurveyCodeWithCompetitors(surveyCode, callback, chartApp) {
    if (!UserService.isLoggedIn() || surveyCode == "") {
      return;
    }
    const params = new URLSearchParams();
    params.append("userId", UserService.getUserId());
    params.append("surveyCode", surveyCode);
    params.append("includeCompetitors", "Y");

    await axios
      .post(API_URL + "/get-metric-groups-by-survey-code", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MetricServices.getMetricGroup", error, "admin", chartApp);
      });
  }

  async getMetricGroup(metricGroupId, mode, callback, chartApp) {
    const params = new URLSearchParams();
    params.append("userId", UserService.getUserId());
    params.append("metricGroupId", metricGroupId);
    params.append("mode", mode);

    await axios
      .post(API_URL + "/get-metric-group", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MetricServices.getMetricGroup", error, "admin", chartApp);
      });
  }
  async getAllMetricGroupList(callback, chartApp) {
    const params = new URLSearchParams();
    params.append("userId", UserService.getUserId());
    await axios
      .post(ADMIN_URL + "/get-all-metric-group-list", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MetricServices.getAllMetricGroupList", error, "admin", chartApp);
      });
  }
  async getAllMetricList(callback, chartApp) {
    const params = new URLSearchParams();
    params.append("userId", UserService.getUserId());
    await axios
      .post(ADMIN_URL + "/get-all-metric-list", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MetricServices.getAllMetricGroupList", error, "admin", chartApp);
      });
  }
  async getMetricList(callback, chartApp) {
    const params = new URLSearchParams();
    params.append("userId", UserService.getUserId());
    params.append("clientCode", ClientService.getClientCode());
    await axios
      .post(API_URL + "/get-metric-list", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MetricServices.getMetricList", error, "admin", chartApp);
      });
  }
  async getMetricTypes(callback, chartApp) {
    await axios
      .get(API_URL + "/get-metric-types", { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MetricServices.getMetricDisplayTypes", error, "admin", this);
      });
  }
  async getCorrelationTypes(callback, chartApp) {
    const params = new URLSearchParams();
    params.append("userId", UserService.getUserId());
    await axios
      .post(API_URL + "/get-correlation-types", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MetricServices.getCorrelationTypes", error, "admin", chartApp);
      });
  }
  async getMetricDisplayTypes(callback, chartApp) {
    await axios
      .get(API_URL + "/get-metric-display-types", { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MetricServices.getMetricDisplayTypes", error, "admin", this);
      });
  }
  async saveMetricList(stringMetricList, metricGroupId, mode, callback, chartApp) {
    const params = new URLSearchParams();
    params.append("stringMetricList", stringMetricList);
    params.append("metricGroupId", metricGroupId);
    params.append("mode", mode);
    params.append("userId", UserService.getUserId());
    await axios
      .post(API_URL + "/save-metrics", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MetricsService.saveMetricList", error, "admin", chartApp);
      });
  }
  async deleteMetricGroup(metricGroupId, callback, chartApp) {
    const params = new URLSearchParams();
    params.append("metricGroupId", metricGroupId);
    params.append("userId", UserService.getUserId());
    await axios
      .post(API_URL + "/delete-metric-group", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MetricsService.deleteMetricGroup", error, "admin", chartApp);
      });
  }
  async deleteMetric(metricId, callback, chartApp) {
    const params = new URLSearchParams();
    params.append("metricId", metricId);
    params.append("userId", UserService.getUserId());
    await axios
      .post(API_URL + "/delete-metric", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MetricsService.deleteMetric", error, "admin", chartApp);
      });
  }
  async importFile(importClientImportFile, metricGroup, mode, callback, chartApp) {
    let formData = new FormData();
    formData.append("file", importClientImportFile);
    formData.append("mode", mode);
    formData.append("userId", UserService.getUserId());
    formData.append("clientCode", ClientService.getClientCode());
    formData.append("metricGroupId", metricGroup.metricGroupId);
    formData.append("metricDisplayTypeId", metricGroup.metricDisplayTypeId);
    formData.append("metricGroupName", metricGroup.name);
    formData.append("calculatedGrowthRate", metricGroup.calculatedGrowthRate);
    formData.append("metricTypeId", metricGroup.metricTypeId);
    formData.append("minimumOutliers", metricGroup.minimumOutliers); 
    formData.append("maximumOutliers", metricGroup.maximumOutliers);
    formData.append("sequenceNumber", metricGroup.sequenceNumber);
    formData.append("correlationTypeId", metricGroup.correlationTypeId);
    formData.append("calculationTypeId", metricGroup.calculationTypeId);

    let headers = await authHeader();

    await axios
      .post(API_URL + "/import-metrics", formData, { headers: headers })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MetricsService.importFile", error, "admin", chartApp);
      });
  }

  async saveMetricGroup(mode, metricGroup, stringConfiguration, stringMetricList, callback, chartApp) {
    const params = new URLSearchParams();
    params.append("mode", mode);
    params.append("metricGroupId", metricGroup.metricGroupId);
    params.append("metricDisplayTypeId", metricGroup.metricDisplayTypeId);
    params.append("metricGroupName", metricGroup.metricGroupName);
    params.append("calculatedGrowthRate", metricGroup.calculatedGrowthRate);
    params.append("metricTypeId", metricGroup.metricTypeId);
    params.append("minimumOutliers", metricGroup.minimumOutliers); 
    params.append("maximumOutliers", metricGroup.maximumOutliers);
    params.append("clientCode", ClientService.getClientCode());
    
    if(metricGroup.clientCompetitorsId != "" && typeof metricGroup.clientCompetitorsId != "undefined") {
      params.append("clientCompetitorsId", metricGroup.clientCompetitorsId);
    } else {
      params.append("clientCompetitorsId", null);
    }
    params.append("userId", UserService.getUserId());
    params.append("stringMetricList", stringMetricList);
    params.append("stringConfiguration", stringConfiguration);
    params.append("sequenceNumber", metricGroup.sequenceNumber);
    params.append("correlationTypeId", metricGroup.correlationTypeId);
    params.append("calculationTypeId", metricGroup.calculationTypeId);

    await axios
      .post(API_URL + "/save-metric-group", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MetricGroups.saveMetricGroup", error, "admin", chartApp);
      });
  }
  getDefaultMetricGroup() {
    return {
      metricGroupId: 0,
      metricTypeId: 0,
      metricDisplayTypeId: 0,
      name: "",
      calculatedGrowthRate: "Sequentially",
      clientId: ClientService.getClientId(),
      configuration: {},
      minimumOutliers: null, 
      maximumOutliers: null,
      sequenceNumber: null,
      correlationTypeId: 1,
      calculationTypeId: 1,
    };
  }
  getDefaultMetric() {
    return {
      metricGroupId: 0,
      metricDisplayTypeId: 0,
      metricGrowth: 0,
      metricId: null,
      metric: 0,
      year: new Date().getFullYear(),
      period: 1
    };
  }
  getCurrentDateDefaultMetric() {
    let currentDate = new Date();
    let currentMonth = currentDate.getMonth() + 1;
    let currentPeriod = Math.ceil(currentMonth / 3);
    return {
      metricGroupId: 0,
      metricDisplayTypeId: 0,
      metricGrowth: 0,
      metricId: null,
      metric: 0,
      year: currentDate.getFullYear(),
      period: currentPeriod
    };
  }
  getTableColumnData() {
    return [
      {
        data: "metricGroupId",
        type: "number",
        createdCell: function(td, cellData, rowData, row, col) {
          $(td).addClass("text-center");
        },
        className: "",
        name: "id",
        width: "8rem"
      },
      { data: "name", name: "name", width: "8rem" },
      { data: "sequenceNumber", name: "sequenceNumber", width: "6rem", type: "number",
        createdCell: function(td, cellData, rowData, row, col) {
          $(td).addClass("text-center");
        },
        render: function (data, type) {
          if (type === "display") {
            return data === -1 ? "" : data; // blank if -1
          }
          if (type === "sort") {
            // push -1 values to the bottom in both asc & desc
            return data === -1 ? Number.MAX_SAFE_INTEGER : data;
          }
          return data; // use raw number for sorting/filtering
        }
      },
      { data: "metricTypeName", name: "metricTypeName", width: "9rem" },
      { data: "metricDisplayTypeName", name: "metricDisplayTypeName", width: "9rem" },
      { data: "calculatedGrowthRate", name: "calculatedGrowthRate", width: "7rem" },
      { data: "correlationTypeName", name: "correlationTypeName", width: "6rem" },
      { data: "calculationTypeName", name: "calculationTypeName", width: "8rem" },
      { data: "clientId", name: "clientId", class: "text-left", width: "6rem", type: "number" },
      { data: "clientCompetitorsId", name: "clientCompetitorId", class: "text-left", width: "9rem", type: "number" },
      { data: "companyName", name: "companyName", width: "12rem" },
      { data: "surveyName", name: "surveyName", width: "12rem" },
      TableService.getActiveColumn(),
      TableService.getDateColumn("dateCreated"),
      TableService.getDateColumn("dateModified")
    ];
  }
  getMetricTableColumnData() {
    return [
      {
        data: "metricId",
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).addClass("text-center");
        },
        className: "",
        name: "id",
        width: "6rem"
      },
      { data: "metric", name: "metric", class: "text-left", width: "5rem" },
      { data: "metricGrowth", 
        name: "metricGrowth", 
        class: "text-left",
        width: "8rem",
        render: function(data, type, row) {
          let v = row.metricGrowth;
          let useValueToCalculateGrowth =  typeof row.calculatedGrowthRate != "undefined" && (row.calculatedGrowthRate == "YoY-Value"|| row.calculatedGrowthRate == "Sequentially-Value");    
          const digits = row.metricDisplayTypeName === "Percent (3 digits)" ? 3 : 2;
          if (v != null && !isNaN(v)) {
            if (useValueToCalculateGrowth) {
              return Number(v).toFixed(digits);
            }
            return Number(v).toFixed(digits) + "%";
          } else {
            return "--";
          }
        }      
      },
      { data: "year", name: "year", class: "text-left", width: "5rem" },
      { data: "period", name: "period", class: "text-left", width: "5rem" },
      {
        data: "metricGroupId",
        createdCell: function (td, cellData, rowData, row, col) {
          $(td).addClass("text-center");
        },
        className: "",
        name: "id",
        width: "8rem"
      },
      { data: "name", name: "name", width: "9rem" },
      { data: "metricTypeName", name: "metricTypeName", width: "8rem" },
      { data: "metricDisplayTypeName", name: "metricDisplayTypeName", width: "9rem" },
      { data: "clientId", name: "clientId", class: "text-left", width: "5rem" },
      { data: "clientCompetitorsId", name: "clientCompetitorsId", class: "text-left", width: "9rem" },
      { data: "clientName", name: "clientName", width: "10rem" },
      TableService.getActiveColumn(),
      TableService.getDateColumn("dateCreated"),
      TableService.getDateColumn("dateModified")
    ];
  }

  async saveMetricGroupSequence(metricGroupList, callback, chartApp) {
    const params = new URLSearchParams();
    params.append("stringMetricGroupList", JSON.stringify(metricGroupList));
    params.append("userId", UserService.getUserId());
    
    await axios
      .post(API_URL + "/save-metric-group-sequence", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MetricGroups.saveMetricGroupSequence", error, "admin", chartApp);
      });
  }

  async getCalculationTypes(callback, chartApp) {
    const params = new URLSearchParams();
    params.append("userId", UserService.getUserId());
    await axios
      .post(API_URL + "/get-calculation-types", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        ErrorService.processError("MetricServices.getCalculationTypes", error, "admin", chartApp);
      });
  }
}

export default new MetricsService();
